import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorPalette } from '../../../../theme';

export const useAccountStyles = makeStyles((theme: Theme) =>
  createStyles({
    fullWidth: {
      width: '100%',
    },
    halfWidth: {
      width: '50%',
    },
    borderRight: {
      borderRight: `1px solid ${colorPalette.gray._300}`,
      width: '50%',
    },
    creditCard: {
      width: '50%',
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      justifyContent: 'center',
      borderBottom: `1px solid ${colorPalette.dark._500}`,
    },
    billingInfoMessage: {
      width: '100%',
      margin: theme.spacing(1),
    },
  })
);
